
export function init_showOnScroll() {
  const canVerticalScroll = () => {
    let documentHeight = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.offsetHeight,
      document.body.clientHeight,
      document.documentElement.clientHeight
    );
    const fv = document.querySelector('.p-top-fv');
    const windowHeight = window.innerHeight;
    documentHeight -= fv.offsetHeight;
    return documentHeight > windowHeight;
  }
  const fv = document.querySelector('.p-top-fv');
  const header = document.querySelector('.js-show-on-scroll');
  if (!canVerticalScroll()) {
    header.classList.add('is-shown');
  }
  window.addEventListener('scroll', function() {
    if (!canVerticalScroll()) {
      return;
    }
    if (fv.offsetHeight < window.scrollY) {
      header.classList.add('is-shown');
    } else {
      header.classList.remove('is-shown');
    }
  });
};